import { useMemo } from 'react';
import { TTranslateTextType } from 'src/hooks/useTranslationHook';
import { TabItem } from 'src/views/components/components.interfaces';
import DashboardFinanceTabView from './dashboardFinanceTab.view';
import DashboardPeopleTabView from './dashboardPeopleTab.view';
import DashboardEventsTabView from './dashboardEventsTab.view';
import { useRbacState } from 'src/context/rbac.context';
import { hasReadPermission } from 'src/utils/rbacHelpers';

export const useDashboardTabMenuItems = (
  translateText: TTranslateTextType
): TabItem[] => {
  const { rbac } = useRbacState();

  return useMemo(() => {
    const tabs: TabItem[] = [];

    if (hasReadPermission(rbac, 'dashboard', 'finance')) {
      tabs.push({
        label: translateText('dashboard.tabs.finance'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: <DashboardFinanceTabView />,
      });
    }

    if (hasReadPermission(rbac, 'dashboard', 'people')) {
      tabs.push({
        label: translateText('dashboard.tabs.people'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: <DashboardPeopleTabView />,
      });
    }

    if (hasReadPermission(rbac, 'dashboard', 'events')) {
      tabs.push({
        label: translateText('dashboard.tabs.events'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: <DashboardEventsTabView />,
      });
    }

    return tabs;
  }, [rbac, translateText]);
};
